import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getEditModelResource } from '@jira/router-resources__classic-projects/src/getEditModelResource.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { csmAppSidebarEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-csm-app/src/csmAppSidebarEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { queuesConfigEntrypoint } from '@jira/spa-apps__servicedesk-queues-config/src/queuesConfigEntrypoint.entrypoint.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import {
	getQueuesResources,
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
	getQueueViewConfigResource,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { csmQueuesViewsConfigRoute } from '@jira/router-routes__servicedesk-queues-routes/src/csmQueuesViewsConfigRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const csmQueuesViewsConfigPageEntrypoint = createPageEntryPoint({
	main: queuesConfigEntrypoint,
	leftSidebar: {
		sidebar: csmAppSidebarEntryPoint,
		isProjectsExpanded: true,
	},
});

export const csmQueuesViewsConfigRouteEntry: Route = createEntry(csmQueuesViewsConfigRoute, () => ({
	group: 'customer-service',
	layout: serviceProjectLayout,

	navigation: {
		sidebarId: SidebarIdCsmApp,
	},

	resources: [
		...getCustomerServiceL1NavigationResources(),
		...getQueuesResources(),
		getConsolidationStateResource(),
		...getServiceDeskNavigationResources(),
		...getServicedeskPageContextResources(),
		...getQueueViewConfigResource(),
		getEditModelResource(),
	],

	entryPoint() {
		return fg('csm_appification_standalone_navigation')
			? csmQueuesViewsConfigPageEntrypoint
			: notFoundPageEntrypoint;
	},

	ufoName: 'service-management.views.config',

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
